'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import globalNavHeight from 'nav-meta/global-nav-height';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { JUPITER_LAYER } from 'HubStyleTokens/sizes';
const StyledSearchSelectWrapper = styled.div.withConfig({
  displayName: "SearchSelectWrapper__StyledSearchSelectWrapper",
  componentId: "sc-1rz9uz9-0"
})(["z-index:", ";transition:padding 0.2s ease;padding-bottom:", "px;&.sticky{position:fixed;top:0;left:0;width:100%;height:", ";padding:5px 8px;background-image:linear-gradient( ", ",", ",", " );}@media screen and (max-width:", "){padding-bottom:32px;}"], JUPITER_LAYER, props => props.paddingBottom || 40, globalNavHeight, props => props.gradientAngle || '-303deg', props => props.startGradientColor, props => props.endGradientColor, GRID_BREAKPOINT_SMALL);
const SearchSelectWrapper = /*#__PURE__*/forwardRef(({
  children,
  isSticky,
  gradientAngle,
  startGradientColor,
  paddingBottom,
  endGradientColor
}, ref) => /*#__PURE__*/_jsx(StyledSearchSelectWrapper, {
  ref: ref,
  className: isSticky ? "sticky" : "",
  gradientAngle: gradientAngle,
  startGradientColor: startGradientColor,
  paddingBottom: paddingBottom,
  endGradientColor: endGradientColor,
  children: children
}));
SearchSelectWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isSticky: PropTypes.bool.isRequired,
  gradientAngle: PropTypes.string,
  startGradientColor: PropTypes.string.isRequired,
  paddingBottom: PropTypes.number,
  endGradientColor: PropTypes.string.isRequired
};
export default SearchSelectWrapper;